{
  "title": "如何查看指派給我的作品",
  "description": "在評審工作區查看主辦方指派給您的所有作品及其目前評分進度。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您可以看到主辦方指派給您的每一件作品、目前評分進度，以及每件作品的匿名編號。",
  "roleNote": "評審",
  "prerequisites": ["已接受評審邀請並登入"],
  "pathLabel": "評審工作區 → 我的指派清單",
  "steps": [
    {
      "title": "1. 開啟評審工作區",
      "description": "登入後進入「評審工作區」，畫面會列出主辦方指派給您的所有作品卡片。"
    },
    {
      "title": "2. 依輪次篩選",
      "description": "若競賽有多個輪次，可切換輪次以只查看該輪次的指派；每張卡片會標示所屬輪次與評分規準版本。"
    },
    {
      "title": "3. 依評分進度篩選",
      "description": "可切換「全部／待評／草稿／已送出」篩選，快速找出尚未處理的作品。清單頂端會顯示審查截止時間與剩餘時間（逾期會標示紅色「已逾期」）以及整體完成進度條，未完成的作品排在前面。首次進入某場競賽時，需先閱讀並勾選「評審須知與保密確認」。"
    },
    {
      "title": "4. 查看單一作品",
      "description": "點選卡片進入評分頁，可看到作品以匿名代碼呈現（而非參賽者真實隊名），以及對應的評分規準與已上傳的繳交檔案；若參賽者填了網址類欄位（如影片繳交網址），也會列在「作品連結」，YouTube／Vimeo 網址可切換到「影片」分頁直接播放。"
    }
  ],
  "afterward": [
    "清單即時反映每件作品目前的評分狀態（尚未開始／草稿／已送出）",
    "已標記利益迴避的作品仍會留在清單中，但會顯示「已申報迴避」徽章且無法評分",
    "作品內容以匿名代碼呈現，不會直接顯示參賽隊伍名稱"
  ],
  "nextSteps": "找到要評分的作品後，請見「如何評分並正式送出」完成評分。",
  "faq": [
    {
      "q": "指派清單裡的作品為什麼是匿名代碼而不是隊名？",
      "a": "這是刻意設計，讓評審在評分時盡量不受隊伍身分影響，維持評分公正性；匿名代碼由系統依作品 ID 產生。"
    },
    {
      "q": "為什麼有些作品卡片顯示「已申報迴避」且無法點進去評分？",
      "a": "這代表您（或主辦方）已針對該作品申報利益迴避；作品仍會留在清單中讓您與主辦方都能看到這筆指派存在，但評分功能與檔案下載都會被系統拒絕。"
    },
    {
      "q": "指派清單找不到某件應該指派給我的作品，怎麼辦？",
      "a": "請聯絡該場競賽的主辦方確認指派是否已建立、輪次是否正確，或是否曾因重複指派／利益衝突被自動略過。"
    }
  ]
}
